<template>
    <app-layout v-if="isPageReady">
        <common-page-plain>
            <common-content-spacer height="medium">
                <common-page-header
                    :heading="$t('pages.referrals.new.steps.search.heading')"
                    :content="$t('pages.referrals.new.steps.search.description')"
                    :isCenter="true"
                ></common-page-header>
                <common-loader v-if="isLoading" :isProcessing="isLoading"></common-loader>
                <common-content-wrapper v-else width="small">
                    <referrals-new-search-form
                        :insurancePlans="insurancePlans"
                        :specialities="specialities"
                        :states="states"
                        :facilityServices="facilityServices"
                        :patientDetails="patientDetails"
                        @sent="showResults($event)"
                        @open-paywall-modal="openPaywallModal"
                    ></referrals-new-search-form>
                </common-content-wrapper>
            </common-content-spacer>
        </common-page-plain>
        <paywall-modal v-if="isPaywallModalOpen" @close="isPaywallModalOpen = false"></paywall-modal>
    </app-layout>
</template>

<script>
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import PageWithElementsMixin from 'mixins/PageWithElementsMixin'
    import PageWithDataMixin from 'mixins/PageWithDataMixin'
    import ReferralsNewPageMixin from 'mixins/ReferralsNewPageMixin'
    import AppLayout from 'components/layouts/AppLayout'
    import ReferralsNewSearchForm from 'components/forms/ReferralsNewSearchForm'
    import SpecialitiesAPI from 'api/SpecialitiesAPI'
    import StatesAPI from 'api/StatesAPI'
    import PatientAPI from 'api/PatientAPI'
    import Store from '~/store'
    export default {
        mixins: [PageWithTitleMixin, PageWithElementsMixin, PageWithDataMixin, ReferralsNewPageMixin],

        components: {
            AppLayout,
            ReferralsNewSearchForm,
        },

        data() {
            return {
                insurancePlans: [],
                specialities: [],
                states: [],
                facilityServices: [],
                isPaywallModalOpen: false,
                isLoading: false,
                patientDetails: {},
            }
        },

        methods: {
            showResults(query) {
                this.$router.push({
                    name: 'pool.new.results',
                    query: query,
                    params: {
                        existingReferral: this.$route.params.existingReferral,
                    },
                })
            },

            openPaywallModal() {
                this.isPaywallModalOpen = true
            },

            getPageData() {
                this.isLoading = true
                Promise.all([SpecialitiesAPI.getList(), StatesAPI.getList()])
                    .then(([specialities, states]) => {
                        this.specialities = specialities
                        this.states = states
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            },

            loadData() {
                if (this?.$route?.query?.patientId) {
                    PatientAPI.getPatientDetails(this.$route.query.patientId, this.$auth.getUser().id)
                        .then((res) => {
                            this.patientDetails = res
                        })
                        .finally(() => {
                            this.isLoading = false
                        })
                }
            },
        },

        mounted() {
            this.getPageData()
            this.loadData()
            this.insurancePlans = Store.getters['auth/getInsurancePlans']
        },
    }
</script>
